import moment from "moment";
import {WizTableForm} from "../../index";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = (self) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "认证名称",
      name: "name",
      dataIndex: "name",
      searchItem: {},
      tableItem: {width: 200},
    },
    {
      title: "品牌",
      name: "orgName",
      dataIndex: "orgName",
      tableItem: {width: 200},
    },
    {
      title: "品牌",
      name: "orgIds",
      dataIndex: "orgIds",
      searchItem: {
        diy: WizTableForm,
        ...WizTableForm.Config.organization(self, {
          apiParams: {
            state: 1,
            organizationNodeCategory: ["2"]
          }
        })
      }
    },
    {
      title: "考评场次",
      name: "studentCount",
      dataIndex: "studentCount",
      tableItem: {
        width: 200
      }
    },
    {
      title: "考卷上传人",
      name: "examCreatorName",
      dataIndex: "examCreatorName",
      tableItem: {width: 100}
    },
    {
      title: "上传日期",
      name: "examCreateDate",
      tableItem: {
        width: 150,
        render: (text, record) => {
          return formatterDate(text)
        }
      },
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'remoteAuth/listByPage',
    ...api,
  }
}

const remoteAuth = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'name',
    columns: columns(self),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default remoteAuth
